import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">Appshow</Link>
            <p className="footer-tagline">
              Apps built to solve real problems. Each product is crafted with
              attention to detail and user experience.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Products</h4>
            <ul>
              <li><Link to="/sexlife-tracker">My SexLife Tracker</Link></li>
              <li><Link to="/growiq">GrowIQ</Link></li>
              <li><Link to="/feel-o-meter-ai-mood-tracker">Feel-O-Meter</Link></li>
              <li><Link to="/rewardly-ai-card-rewards">Rewardly AI</Link></li>
              <li><Link to="/price-tracker-deal-alerts">Price Tracker</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/rewardly-ai-card-rewards/support">Support</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Appshow. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
